export interface ApiResponse<A> {
  response?: Response;
  body?: A | null;
  error?: Error;
}

export function createApiResponse<A>(response?: Response, body?: A | null, error?: Error): ApiResponse<A> {
  return { response, body, error };
}
